import { INVENTORY_TYPES } from 'client/constants/inventory-types';

export function isUsed(type) {
  return type.toUpperCase() === INVENTORY_TYPES.USED || type.toUpperCase() === INVENTORY_TYPES.CPO;
}
